module.exports = __webpack_public_path__ + "img/quality.4367bc01.png";